'use client'

import { startTransition, useCallback } from 'react'

import type { FormEvent } from 'react'

export function usePreservedSubmit(action: (formData: FormData) => void) {
  return useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      const submitter = (event.nativeEvent as SubmitEvent).submitter
      const formData = new FormData(event.currentTarget, submitter)
      startTransition(() => action(formData))
    },
    [action]
  )
}
